(function () {
  var root = document.querySelector('[data-collection]');
  if (!root) return;

  var filtersForm = root.querySelector('#CollectionFilters');
  var toolbarForm = root.querySelector('#CollectionFilterForm');

  // Auto-submit filter form on checkbox / sort change
  function submitFilters() {
    if (filtersForm) filtersForm.submit();
  }

  root.querySelectorAll('#CollectionFilters [data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', submitFilters);
  });

  // Sort select lives in the toolbar form: merge its value into the filter query
  var sortSelect = root.querySelector('#CollectionSort');
  if (sortSelect && filtersForm) {
    sortSelect.addEventListener('change', function () {
      var hidden = filtersForm.querySelector('input[name="sort_by"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'sort_by';
        filtersForm.appendChild(hidden);
      }
      hidden.value = sortSelect.value;
      submitFilters();
    });
  }

  // Filter accordions
  root.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var head = acc.querySelector('[data-accordion-head]');
    var body = acc.querySelector('[data-accordion-body]');
    if (!head || !body) return;
    head.addEventListener('click', function () {
      var open = head.getAttribute('aria-expanded') === 'true';
      head.setAttribute('aria-expanded', String(!open));
      body.style.display = open ? 'none' : '';
      acc.classList.toggle('is-collapsed', open);
    });
  });

  // Mobile sidebar drawer
  var toggle = root.querySelector('[data-filter-toggle]');
  var sidebar = root.querySelector('[data-sidebar]');
  var overlay = root.querySelector('[data-filter-overlay]');
  var closeBtn = root.querySelector('[data-filter-close]');

  function openSidebar() {
    if (!sidebar) return;
    sidebar.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openSidebar);
  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay) overlay.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSidebar();
  });

  // View toggle (grid / list)
  var views = root.querySelector('[data-views]');
  var grid = root.querySelector('[data-grid]');
  if (views && grid) {
    var stored = null;
    try { stored = localStorage.getItem('talie-collection-view'); } catch (e) {}
    if (stored === 'list') applyView('list');

    views.querySelectorAll('[data-view]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyView(btn.getAttribute('data-view'));
      });
    });
  }

  function applyView(mode) {
    if (!grid || !views) return;
    grid.classList.toggle('is-list', mode === 'list');
    views.querySelectorAll('[data-view]').forEach(function (btn) {
      var active = btn.getAttribute('data-view') === mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
    try { localStorage.setItem('talie-collection-view', mode); } catch (e) {}
  }
})();
